<!--
  @修改人: 谢汉 
  @修改时间：2019-11-25
  @修改描述：活跃用户
  @版本:v2.0.11
-->
<template>
  <div class="activeUser__content">
    <div class="config-wrap">
      <el-popover
        placement="bottom-end"
        trigger="click"
        v-model="showPop">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item :label="$t('common.time')" input-width="auto">
          <el-form-item prop="startTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="date">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="endTime" style="margin-left: 10px">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="date">
            </el-date-picker>
          </el-form-item>
          </el-form-item>
          <el-button type="primary" 
            @click="searchTime"
            v-g-rac="gRac('activeUser@search')"
            v-text="$t('common.search')"></el-button>
          <el-button type="primary"
            @click="e_export"
            v-g-rac="gRac('activeUser@export')" 
            v-text="$t('hostList.export')"></el-button>
        </el-form>
        <el-button type="text" @click="showPop = !showPop" slot="reference" v-text="$t('networkTopology.choose')"></el-button>
      </el-popover>
    </div>
    <div id="activeUser" :style="chartStyle" v-show="!noData"></div>
    <div v-show="noData" v-text="$t('common.noData')" style="text-align: center;"></div>
  </div>
</template>
  
<script>
  import rac from '@/plugins/rac-mixin'
  import activeUserBiz from '@/logic/systemDiagram/activeUserBiz'
  import EventCenter from '@/utils/eventCenter'
  import exportTips from '@/components/mixins/exportTips'
  import echarts from 'echarts'
  import { extend } from '@/utils/tool'
  const eventCenter = EventCenter()
  export default {
    mixins: [exportTips, rac],
    data () {
      return {
        chartInstance: null,
        chartStyle: {
          width: '600px',
          height: '400px'
        },
        chartOption: {
          tooltip: { trigger: 'axis' },
          color: ['#FF0000', '#0000FF'],
          legend: { data: [] },
          grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
          xAxis: { type: 'category', boundaryGap: false, data: [] },
          yAxis: { type: 'value' },
          series: [{ name: '', type: 'line', data: [] },
            { name: '', type: 'line', data: [] }]
        },
        noData: false,
        showPop: false,
        searchForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime() - 15 * 86400000,
          endTime: new Date(new Date().toLocaleDateString()).getTime()
        },
        doExport: null
      }
    },
    components: {},
    methods: {
      setChartInstance () {
        if (!this.chartInstance) this.chartInstance = echarts.init(document.getElementById('activeUser'))
      },
      searchTime () {
        activeUserBiz.queryHisDailyTml({ ...this.searchForm }).then((data) => {
          if (data && data.dataList) {
            this.noData = false
            let time = []
            let activeUser = []
            let activeTml = []
            data.dataList.map(item => {
              time.push(new Date(item.time).toJSON().substr(0, 10))
              activeUser.push(item.activeUser)
              activeTml.push(item.activeTml)
            })
            this.chartOption.legend.data = [this.$t('activeUser.activeUser'), this.$t('activeUser.activeTml')]
            this.chartOption.xAxis.data = time
            this.chartOption.series[0].data = activeUser
            this.chartOption.series[1].data = activeTml
            this.chartOption.series[0].name = this.chartOption.legend.data[0]
            this.chartOption.series[1].name = this.chartOption.legend.data[1]
            this.setChartInstance()
            this.chartInstance.setOption(this.chartOption)
            this.setChartStyle()
            this.setResize()
          } else {
            this.noData = true
          }
        })
      },
      e_export () {
        const search = extend({}, this.searchForm)
        if (!this.doExport) this.doExport = this.exportTable()
        this.doExport(search)
      },
      exportTable () {
        const that = this
        const list = { time: 'time', activeUser: 'activeUser', activeTml: 'activeTml' }
        return function (search) {
          that.exRenderBefore()
          activeUserBiz.exportActiveUser(
            list,
            search,
            ['time'],
            that.exRenderTips,
            that.exRenderFail
          )
        }
      },
      setChartStyle () {
        this.chartStyle.width = document.getElementsByClassName('tabView')[0].clientWidth - 66 + 'px'
        this.chartStyle.height = document.getElementsByClassName('tabView')[0].clientHeight - 60 + 'px'
      },
      resizeEvent () {
        this.setChartStyle()
        this.$nextTick(() => {
          this.resize()
        })
      },
      resize () {
        if (this.chartInstance && !this.chartInstance.isDisposed()) {
          this.chartInstance.resize()
        }
      },
      setResize () {
        this.resizeEvent()
        eventCenter.addResizeEvent('logStatisticsChart', () => {
          this.resizeEvent()
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'activeUser') {
          this.setResize()
        } else if (from.name === 'activeUser') {
          eventCenter.removeResizeEvent('activeUser')
        }
      }
    },
    mounted () {
      this.searchTime()
    }
  }
</script>
  
<style scoped>
  .config-wrap {
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 9;
  }
</style>